import { gql } from 'apollo-boost';
 
export const GET_NETWORK_BY_USER = gql`
query userNetworks($user: String!) {
  userNetworks(user: $user) {
        id
        network {
        id
        name
        }
    }      
  }  
`;

export const ADD_EDIT_NETWORK_USER_ACCESS = gql`
mutation createUserNetworks($user: String!, $networks: [String!]!){
    createUserNetworks(input: {
        networks: $networks,
        user: $user
  }) {
    network {
        name
      }
      id
  }
}
`;